import React from "react";
import AppBar from "../app-bar/app-bar";
import AllProductPage from "../data-tables-distributor/products-table/all-products";
import {useUser} from "../providers/user-context";

function AllProductsDistributor({navOpen, toggleNav}) {
    const {userFullName, tenantName, tenantType} = useUser();
    return (
        <div style={{ display: 'flex', marginTop: '60px' }}>
            <AppBar userFullName={userFullName} tenantName={tenantName} type={tenantType} navOpen={navOpen} toggleNav={toggleNav}/>
            {(tenantType === "IMPORTER" || tenantType === "SYSTEM") && <AllProductPage navOpen={navOpen} tenantType={tenantType}/>}
        </div>
    );
}
export default AllProductsDistributor;
